export const Upload = ({ width, height, viewBox, styles, fill }) => {
  return (
    <svg
      width={width || '40'}
      height={height || '40'}
      viewBox={viewBox || '0 0 40 40'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9696 11.659C26.0909 10.7803 24.6663 10.7803 23.7876 11.659L12.8484 22.5983C11.3839 24.0628 11.3839 26.4372 12.8484 27.9016C14.3128 29.3661 16.6872 29.3661 18.1517 27.9016L25.8446 20.2087C26.1375 19.9158 26.6124 19.9158 26.9053 20.2087C27.1982 20.5015 27.1982 20.9764 26.9053 21.2693L19.2123 28.9623C17.1621 31.0126 13.8379 31.0126 11.7877 28.9623C9.73744 26.9121 9.73744 23.5879 11.7877 21.5377L22.7269 10.5984C24.1914 9.13388 26.5658 9.13388 28.0302 10.5983C29.4947 12.0628 29.4947 14.4372 28.0302 15.9016L17.0973 26.8346C17.0945 26.8374 17.0917 26.8403 17.0888 26.8432L17.0819 26.85L17.0797 26.8522L17.0775 26.8544C16.1976 27.7196 14.7832 27.7152 13.909 26.841C13.0303 25.9623 13.0303 24.5377 13.909 23.659L21.7195 15.8483C22.0124 15.5554 22.4873 15.5554 22.7802 15.8483C23.0731 16.1412 23.0731 16.6161 22.7802 16.909L14.9697 24.7197C14.6768 25.0125 14.6768 25.4874 14.9697 25.7803C15.2604 26.0711 15.7306 26.0732 16.0238 25.7867L26.9696 14.841C27.8483 13.9623 27.8483 12.5377 26.9696 11.659Z"
        fill={fill || '#555555'}
      />
    </svg>
  );
};
